import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'LoginNotification' })({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        padding: '32px 20px 32px 20px',
        background: `url(/static/img/common/login-notification-bg.webp) center / cover no-repeat #232323`,
        position: 'sticky',
        bottom: 8,
        marginLeft: 8,
        marginRight: 8,
        borderRadius: 24,
        zIndex: 100
    },
    title: {
        color: '#fff',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 600,
        lineHeight: '150%',
        margin: 0
    },
    hint: {
        color: '#FFFFFFBF',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%',
        margin: 0
    },
    close: {
        color: '#FFFFFFBF',
        position: 'absolute',
        right: 5,
        top: 5
    },
    oauthButtonGroup: {
        justifyContent: 'center'
    },
    link: {
        color: '#f5726a',
        textDecoration: 'none'
    }
});
